var counter = 1;

var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
    general: {
        limit: boostPFSConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: true,
        //numberFilterTree: 2,
        priceMode: 'max',
    },
    selector: {
      	topSorting: '#bc-sf-filter-top-sorting-no-style',
      	breadcrumb: '.breadcrumb-navigation',
    }
};

// Declare Templates
var boostPFSTemplate = {
  	'productCardAlt': 'product-card-alt',

    // Grid Template
    'productGridItemHtml':  '<li data-boost-theme-quickview="{{itemId}}" class="product product-{{itemId}} {{itemLoopClass}} {{itemCycleClass}} {{itemCardType}}" data-product-item>' +
                				'<div class="product-inner">' +
                			    	'<figure class="product-card-figure">' +
                			    		'{{itemImages}}' +
                			    		'<a href="{{itemUrl}}" class="{{itemBorderClass}}"></a>' +
                			    		'<a class="product-card-overlay {{itemHideOverlayClass}}" href="{{itemUrl}}">' +
                			    			'<div class="product-card-overlay-content">' +
                			    				'{{itemCardOverlay}}' + // enableOverlay ? productCardDetailsOverlayHtml : productCardInteractionsHtml
                			    			'</div>' +
                			    		'</a>' +
                			    		'{{itemBadges}}' +
                			    	'</figure>' +
                			    	'<div class="product-card-footer" id="product-card-interactions-{{itemId}}">' +
                			    		'{{itemCardFooter}}' + // enableOverlay ? productCardInteractionsHtml : productCardDetailsHtml
                			    	'</div>' +
                			    	'<div class="product-card-footer-mobile">' +
                			    		'{{itemCardFooterMobile}}' + // productCardDetailsHtml
                			    	'</div>' +
                			  	'</div>' +
							'</li>',
							
	'productCardDetailsHtml' : 	'<div class="product-card-details">' +
								  	'<h3 class="brand">{{itemVendor}}</h3>'+
									'<h2 class="title">{{itemTitle}}</h2>' +
									'{{itemPrice}}' +
								'</div>',						

    'productCardDetailsOverlayHtml' : 	'<div class="product-card-details">' +
									      	'<h3 class="brand">{{itemVendor}}</h3>'+
									    	'<h2 class="title">{{itemTitle}}</h2>' +
									   		'{{itemPrice}}' +
									 	'</div>',
    
    'productCardInteractionsHtml' : '<div class="product-card-interactions">' +
  										'{{itemQuickShop}}' +
  										'{{itemAddToCart}}' +
  									'</div>',

	'quickShopHtml' : 	'<button class="product-card-interaction product-card-interaction-quickshop"' +
							'data-product-card-interaction-quickshop ' +
							'data-product-sha256="{{itemSHA256}}"' +
							'data-product-url="{{itemUrl}}">' +
		  					boostPFSConfig.label.quickShop +
  						'</button>',

	'addToCartHtml' : 	'<button class="product-card-interaction product-card-interaction-addtocart" {{disabled}}' +	
							'data-product-card-interaction-addtocart ' +
							'data-product-variant-id="{{variantId}}">' +
							'<span class="product-card-interaction-addtocart-available">' +
								'{{addToCartLabel}}' +
							'</span>' +
							'<span class="product-card-interaction-addtocart-error">' +
								boostPFSConfig.label.unAvailable +
							'</span>' +
							'<div class="product-card-interaction-addtocart-spinner">' +
								'<svg class="svg-icon icon-spinner " xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">' +
									'<path fill="currentColor" fill-rule="evenodd" d="M1.0436 10.9683C1.47582 10.9683 1.8262 11.3255 1.8262 11.7661C1.8262 17.4946 6.38122 22.1385 12.0001 22.1385C17.619 22.1385 22.174 17.4946 22.174 11.7661C22.174 11.3255 22.5244 10.9683 22.9566 10.9683C23.3889 10.9683 23.7392 11.3255 23.7392 11.7661C23.7392 18.3759 18.4835 23.7342 12.0001 23.7342C5.51677 23.7342 0.260986 18.3759 0.260986 11.7661C0.260986 11.3255 0.611372 10.9683 1.0436 10.9683Z"></path>' +
								'</svg>' +
							'</div>' +
						'</button>',

    // Pagination Template
    'previousActiveHtml': '<li class="previous"><a href="{{itemUrl}}">' + boostPFSConfig.label.pagination_prev + '</a></li>',
    'previousDisabledHtml': '<li class="previous">' + boostPFSConfig.label.pagination_prev + '</li>',
    'nextActiveHtml': '<li class="next"><a href="{{itemUrl}}">' + boostPFSConfig.label.pagination_next + '</a></li>',
    'nextDisabledHtml': '<li class="next">' + boostPFSConfig.label.pagination_next +  '</li>',
    'pageItemHtml': '<li class="position">Page {{currentPage}} of {{totalPage}}</li>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

    
  	// Sorting Template
    'sortingHtml': '<label for="bc-sf-filter-top-sorting-select" class="sidebar-title">' + boostPFSConfig.label.sorting + '</label>'+
  				   '<span class="bc-sf-sort-select select-wrapper">' +
  						'<select id="bc-sf-filter-top-sorting-select" class="sort-by-box-okay">{{sortingItems}}</select>'+
  				   '</span>',
};

(function() {
	BoostPFS.inject(this);
	
	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}
	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data, index) {
		if (!data) data = this.data;
		if (!index) index = this.index;
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);
		
      	if (index == 1) counter = 1;

        // Add custom class
        var itemLoopClass = '';
        if (index == 1) {
            itemLoopClass = 'first';
        } else if (index == Globals.queryParams.limit) {
            itemLoopClass = 'last';
        }
        itemHtml = itemHtml.replace(/{{itemLoopClass}}/g, itemLoopClass);

        var itemCycleClass = (index % 5 == 0 || index == 1) ? 'flush' : '';
        itemHtml = itemHtml.replace(/{{itemCycleClass}}/g, itemCycleClass);

        var itemBorderClass = boostPFSConfig.custom.imageBorders ? 'with-border' : '';
        itemHtml = itemHtml.replace(/{{itemBorderClass}}/g, itemBorderClass);

        var itemCardType = boostPFSConfig.custom.enableProductDetailsOverlay ? boostPFSTemplate.productCardAlt : '';
        itemHtml = itemHtml.replace(/{{itemCardType}}/g, itemCardType);

        var itemHideOverlayClass = (boostPFSConfig.custom.enableQuickShop || boostPFSConfig.custom.enableATC) ? '' : 'product-card-overlay--hide';
        itemHtml = itemHtml.replace(/{{itemHideOverlayClass}}/g, itemHideOverlayClass);

        // Add Images
        var itemImagesHtml = '';
        if (images.length > 0) {
            itemImagesHtml += '<img alt="{{itemTitle}}" src="' + Utils.optimizeImage(images[0]['src'], '512x') + '" srcset="' + Utils.optimizeImage(images[0]['src'], '512x') + '" />';
            if (images.length > 1) {
                itemImagesHtml += '<img alt="{{itemTitle}}" src="' + Utils.optimizeImage(images[1]['src'], '512x') + '" srcset="' + Utils.optimizeImage(images[1]['src'], '512x') + '" />';
            }
        } else {
            itemImagesHtml += '<img alt="{{itemTitle}}" src="' + boostPFSAppConfig.general.no_image_url + '" srcset="' + boostPFSAppConfig.general.no_image_url + '" />';
        }
        itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

        // Add Badges
        var itemBadgesHtml = '',
            newTag = boostPFSConfig.label.new;
        itemBadgesHtml += '<div class="badges-wrapper">';
        if (data.available) {
            if (onSale) {
                itemBadgesHtml += '<span class="badge badge-sale">' + boostPFSConfig.label.sale + '</span>';
            }
            if (data.tags.indexOf(newTag) > -1) {
                itemBadgesHtml += '<span class="badge badge-new">' + newTag + '</span>';
            }
        } else {
            itemBadgesHtml += '<span class="badge badge-soldout">' + boostPFSConfig.label.soldOut + '</span>';
        }
        itemBadgesHtml += '</div>';
        itemHtml = itemHtml.replace(/{{itemBadges}}/g, itemBadgesHtml);

        var productCardDetails = boostPFSTemplate.productCardDetailsHtml;
        var productCardDetailsOverlay = boostPFSTemplate.productCardDetailsOverlayHtml;
        var productCardInteractions = buildProductCardInteractions(data, firstVariant);

        // Add Card Overlay
        var itemCardOverlay = boostPFSConfig.custom.enableProductDetailsOverlay ? productCardDetailsOverlay : productCardInteractions;
        itemHtml = itemHtml.replace(/{{itemCardOverlay}}/g, itemCardOverlay);

        // Add Card Footer
        var itemCardFooter = boostPFSConfig.custom.enableProductDetailsOverlay ? productCardInteractions : productCardDetails;
        itemHtml = itemHtml.replace(/{{itemCardFooter}}/g, itemCardFooter);

        // Add Card Footer Mobile
        itemHtml = itemHtml.replace(/{{itemCardFooterMobile}}/g, productCardDetails);

        // Add Vendor
        var itemVendor = boostPFSConfig.custom.showBrandNames ? data.vendor : '';
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendor);

        // Add Price
        var itemPrice = buildPrice(data);
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPrice);

        // Add main attribute (Always put at the end of this function)
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

        counter++;

        return itemHtml;
	};
	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildPrice(data){
        var html = '';
        var onSale = data.compare_at_price_min > data.price_min;
        if (onSale){
            html += '<p class="price sale">';
            html += '<span class="original money">' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + '</span>';
            html += '<span class="money">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span>';
            html += '</p>';
        } else {
            html += '<p class="price"><span class="money">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span><p>';
        }
        return html;
    }

    function buildProductCardInteractions(data, firstVariant) {
        var html = boostPFSTemplate.productCardInteractionsHtml;

        // Add quick shop
        var itemQuickShop = '';
        if (boostPFSConfig.custom.enableQuickShop) {
            itemQuickShop = boostPFSTemplate.quickShopHtml;
            itemQuickShop = itemQuickShop.replace(/{{itemSHA256}}/g, sha256(JSON.stringify(data)));
        }
        html = html.replace(/{{itemQuickShop}}/g, itemQuickShop);

        // Add add to cart
        var itemAddToCart = '';
        if (boostPFSConfig.custom.enableATC) {
            itemAddToCart = boostPFSTemplate.addToCartHtml;

            var disabled = firstVariant.available ? '' : 'disabled';
            itemAddToCart = itemAddToCart.replace(/{{disabled}}/g, disabled);		
            itemAddToCart = itemAddToCart.replace(/{{variantId}}/g, firstVariant.id);

            var addToCartLabel = firstVariant.available ? boostPFSConfig.label.addToCart : boostPFSConfig.label.soldOut;
            itemAddToCart = itemAddToCart.replace(/{{addToCartLabel}}/g, addToCartLabel);	
        }
        html = html.replace(/{{itemAddToCart}}/g, itemAddToCart);

        return html;
    }

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}
		if (Settings.getSettingValue('general.paginationType') == 'default') {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			
            // Build Previous
            var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Build page items
            var pageItemsHtml = boostPFSTemplate.pageItemHtml;
            pageItemsHtml = pageItemsHtml.replace(/{{currentPage}}/g, currentPage);
            pageItemsHtml = pageItemsHtml.replace(/{{totalPage}}/g, totalPage);
        	paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

// 	ProductSorting.prototype.render = function() {
// 		jQ(Selector.topSorting).html(this.compileTemplate());

// 		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
// 			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
// 		}

// 		var labelSort = '';
// 		var paramSort = Globals.queryParams.sort || '';
// 		if (paramSort.length > 0) {
// 			var labelHandle = 'sorting_' + paramSort.replace(/\-/g, '_');
// 			labelSort = Labels[labelHandle];
// 		} else {
// 			labelSort = Labels.sorting_heading;
// 		}

// 		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
// 	}

// 	// Build Sorting event
// 	ProductSorting.prototype.bindEvents = function() {
// 		var _this = this;
// 		jQ('.boost-pfs-filter-filter-dropdown a').click(function(e){
// 			e.preventDefault();
// 			FilterApi.setParam('sort', jQ(this).data('sort'));
// 			FilterApi.setParam('page', 1);
// 			FilterApi.applyFilter('sort');
// 		});

// 		jQ(".boost-pfs-filter-custom-sorting > button").click(function(){
// 			if (!jQ('.boost-pfs-filter-filter-dropdown').is(':animated')) {
// 				jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
// 				//jQ('.boost-pfs-filter-tree-v').hide();
// 			}
// 		});

// 		jQ(Selector.filterTreeMobileButton).click(function(){
// 			jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
// 		});
// 	};
	// Build Breadcrumb
	Breadcrumb.prototype.compileTemplate = function (colData) {
		if (!colData) colData = this.collectionData;
		var breadcrumbItemsHtml = '';
		if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
			if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
				var colInfo = colData.collection;
                var colInfo = colData.collection;
                var breadcrumbHtml = '<span><a href="/">Home</a></span>';
                breadcrumbHtml += '<span class="sep">/</span> ';
                breadcrumbHtml += '<span><a href="/collections">' + boostPFSConfig.label.breadcrumb_collection + '</a></span> ';
                breadcrumbHtml += '<span class="sep">/</span> ';
                breadcrumbHtml += '<span>' + colInfo.title + '</span>';
			} else {
				breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
			}
		}
		return breadcrumbItemsHtml
	};
	/************************** END BUILD TOOLBAR **************************/
	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {
		if (!data) data = this.data;
	
		if (boostPFSConfig.custom.enableQuickShop  || boostPFSConfig.custom.enableATC) {
            // Build content for Quick view
            Utils.buildExtrasProductListByAjax(data, 'boost-integration', function(results){
                results.forEach(function(result){
                    // Append the custom html to product item
                    jQ('[data-boost-theme-quickview="'+ result.id+ '"] .product-card-interaction-quickshop').attr('data-product-sha256', sha256(JSON.stringify(result.quickshop_html)));
                })
            });
        }

        if (bc_atlantic_Atlantic && bc_StaticCollection_StaticCollection){
            var sections = new bc_atlantic_Atlantic();
            sections.register('static-collection', function(section) {
                return new bc_StaticCollection_StaticCollection(section);
            });
        }
	};

	// Build additional elements
	Filter.prototype.afterRender = function(data) {
		
	};

	/* Prevent conflict with theme vendor js */ 
	Array.prototype.insert = function(a, b) {}

	// sha256 of a string and display its hex digest
    function sha256(ascii) {
        function rightRotate(value, amount) {
            return (value>>>amount) | (value<<(32 - amount));
        };

        var mathPow = Math.pow;
        var maxWord = mathPow(2, 32);
        var lengthProperty = 'length'
        var i, j; // Used as a counter across the whole file
        var result = ''

        var words = [];
        var asciiBitLength = ascii[lengthProperty]*8;

        //* caching results is optional - remove/add slash from front of this line to toggle
        // Initial hash value: first 32 bits of the fractional parts of the square roots of the first 8 primes
        // (we actually calculate the first 64, but extra values are just ignored)
        var hash = sha256.h = sha256.h || [];
        // Round constants: first 32 bits of the fractional parts of the cube roots of the first 64 primes
        var k = sha256.k = sha256.k || [];
        var primeCounter = k[lengthProperty];
        /*/
        var hash = [], k = [];
        var primeCounter = 0;
        //*/

        var isComposite = {};
        for (var candidate = 2; primeCounter < 64; candidate++) {
            if (!isComposite[candidate]) {
                for (i = 0; i < 313; i += candidate) {
                    isComposite[i] = candidate;
                }
                hash[primeCounter] = (mathPow(candidate, .5)*maxWord)|0;
                k[primeCounter++] = (mathPow(candidate, 1/3)*maxWord)|0;
            }
        }

        ascii += '\x80' // Append Ƈ' bit (plus zero padding)
        while (ascii[lengthProperty]%64 - 56) ascii += '\x00' // More zero padding
        for (i = 0; i < ascii[lengthProperty]; i++) {
            j = ascii.charCodeAt(i);
            if (j>>8) return; // ASCII check: only accept characters in range 0-255
            words[i>>2] |= j << ((3 - i)%4)*8;
        }
        words[words[lengthProperty]] = ((asciiBitLength/maxWord)|0);
        words[words[lengthProperty]] = (asciiBitLength)

        // process each chunk
        for (j = 0; j < words[lengthProperty];) {
            var w = words.slice(j, j += 16); // The message is expanded into 64 words as part of the iteration
            var oldHash = hash;
            // This is now the undefinedworking hash", often labelled as variables a...g
            // (we have to truncate as well, otherwise extra entries at the end accumulate
            hash = hash.slice(0, 8);

            for (i = 0; i < 64; i++) {
                var i2 = i + j;
                // Expand the message into 64 words
                // Used below if 
                var w15 = w[i - 15], w2 = w[i - 2];

                // Iterate
                var a = hash[0], e = hash[4];
                var temp1 = hash[7]
                    + (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25)) // S1
                    + ((e&hash[5])^((~e)&hash[6])) // ch
                    + k[i]
                    // Expand the message schedule if needed
                    + (w[i] = (i < 16) ? w[i] : (
                            w[i - 16]
                            + (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15>>>3)) // s0
                            + w[i - 7]
                            + (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2>>>10)) // s1
                        )|0
                    );
                // This is only used once, so *could* be moved below, but it only saves 4 bytes and makes things unreadble
                var temp2 = (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) // S0
                    + ((a&hash[1])^(a&hash[2])^(hash[1]&hash[2])); // maj

                hash = [(temp1 + temp2)|0].concat(hash); // We don't bother trimming off the extra ones, they're harmless as long as we're truncating when we do the slice()
                hash[4] = (hash[4] + temp1)|0;
            }

            for (i = 0; i < 8; i++) {
                hash[i] = (hash[i] + oldHash[i])|0;
            }
        }

        for (i = 0; i < 8; i++) {
            for (j = 3; j + 1; j--) {
                var b = (hash[i]>>(j*8))&255;
                result += ((b < 16) ? 0 : '') + b.toString(16);
            }
        }
        return result;
    };

    function hex(buffer) {
        var hexCodes = [];
        var view = new DataView(buffer);
        for (var i = 0; i < view.byteLength; i += 4) {
            // Using getUint32 reduces the number of iterations needed (we process 4 bytes each time)
            var value = view.getUint32(i)
            // toString(16) will give the hex representation of the number without padding
            var stringValue = value.toString(16)
            // We use concatenation and slice for padding
            var padding = '00000000'
            var paddedValue = (padding + stringValue).slice(-padding.length)
            hexCodes.push(paddedValue);
        }

        // Join all the hex strings into one
        return hexCodes.join("");
    }

})();

/* Begin patch boost-010 run 2 */
Filter.prototype.beforeInit=function(){var t=this.isBadUrl();t&&(this.isInit=!0,window.location.href=window.location.pathname)},Filter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var n=0;n<t.length;n++){var i=t[n],r=(i.match(/</g)||[]).length,a=(i.match(/>/g)||[]).length,o=(i.match(/alert\(/g)||[]).length,h=(i.match(/execCommand/g)||[]).length;if(r>0&&a>0||r>1||a>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
